import { readDatasetProperty, writeDatasetProperty } from './attributeAccess';
import { DcmJsDatasetWrapper } from './dcmJsWrapper';
import { multiValuedStringText } from './multiValuedString';
import { personNameToString } from './personName';

export function dcmjsGetString(
    datasetWrapper: DcmJsDatasetWrapper,
    tag: string
): string {
    // Typed first: typed-engine objects hold attributes off the naturalized dataset.
    const typed = readDatasetProperty<string>(datasetWrapper, tag);
    const value: unknown = typed.answered
        ? typed.value
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (datasetWrapper.dataset as any)[tag];
    // A multi-valued string (SoftwareVersions, ImageType) is one text, in order, never comma-joined.
    if (
        Array.isArray(value) &&
        value.every((item) => typeof item === 'string')
    ) {
        return multiValuedStringText(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    // A person name's component groups, a String-wrapped value, or nothing, read as text.
    return personNameToString(value);
}

export function dcmjsSetString(
    datasetWrapper: DcmJsDatasetWrapper,
    tag: string,
    value: string
) {
    if (writeDatasetProperty(datasetWrapper, tag, value)) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (datasetWrapper.dataset as any)[tag] = value;
}
